import { createIcon } from "@chakra-ui/react";

export const Restart = createIcon({
  displayName: "Restart",
  viewBox: "0 0 24 24",
  d: "M16.217 8.572h-1.734c-.61 0-1.103.51-1.103 1.143 0 .632.493 1.142 1.103 1.142h4.414c.61 0 1.103-.51 1.103-1.142V5.144C20 4.512 19.507 4 18.897 4s-1.104.51-1.104 1.143v1.828l-.607-.629C14.17 3.22 9.28 3.22 6.263 6.343c-3.017 3.125-3.017 8.189 0 11.314 3.017 3.124 7.906 3.124 10.923 0a1.174 1.174 0 0 0 0-1.618 1.078 1.078 0 0 0-1.562 0 5.384 5.384 0 0 1-7.803 0c-2.155-2.232-2.155-5.85 0-8.081a5.384 5.384 0 0 1 7.803 0l.593.614z",
  defaultProps: {
    "aria-label": "A circular line ending with an arrow point right"
  }
});

export default Restart;
